import { render, staticRenderFns } from "./userModuleSelect.vue?vue&type=template&id=587d8ef4&scoped=true&"
import script from "./userModuleSelect.vue?vue&type=script&lang=js&"
export * from "./userModuleSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "587d8ef4",
  null
  
)

export default component.exports